import {useQuery} from 'react-query'
import {Get} from '../../../../setup'
import {initialValuesWebFormsDashboardData, WebFormsDashboardData} from '../../../@types'
import {LoadingState, PeriodType} from '../../../../global'
import {Dispatch, SetStateAction, useState} from 'react'
import {useForms} from '../../../@contexts'

const WEB_FORMS = process.env.REACT_APP_V2_DASHBOARD_WEB_FORMS || 'v2/tableau-board'

type Props = {
    period: PeriodType
    setLoading: Dispatch<SetStateAction<LoadingState>>
}

export const useWebFormsData = ({period, setLoading}: Props) => {

    const {reloadKey} = useForms()
    const [data, setData] = useState<WebFormsDashboardData>(initialValuesWebFormsDashboardData)
    const [error, setError] = useState<string | null>(null);

    const {refetch} = useQuery(
        [`WEB_FORMS_DASHBOARD`, period, reloadKey],
        () => Get<WebFormsDashboardData>({endpoint: WEB_FORMS, period}),
        {
            enabled: !!period,
            select: (data) => data,
            onSuccess: (data) => {
                setLoading('fulfilled')
                setData(data)
                setError(null);
            },
            onError: (err: any) => {
                setLoading('rejected')
                setError(err.message || 'Une erreur est survenue')
            },
        },
    )

    return {data, refetch}
}